import { Component, EventEmitter, Input, OnInit, Output, ViewChild } from '@angular/core';
import { NgForm } from '@angular/forms';

import { UntilDestroy, untilDestroyed } from '@ngneat/until-destroy';
import { CFDocumentToDisplay } from '../../../models/cf-document/cf-document-to-display';
import { CFSignatureForComplete } from '../../../models/signatures/cf-signature-for-complete';
import { CustomNotificationService } from '../../../services/custom-notification.service';
import { CFSignatureStoreService } from '../../../services/signatures/cf-signature-store.service';
import { CFSignatureService } from '../../../services/signatures/cf-signature.service';
import { CustomMessagesService } from '../../../services/translation/custom-messages.service';

@UntilDestroy()
@Component({
    selector: 'clfl-sign-with-pin-code',
    templateUrl: './sign-with-pin-code.component.html',
    styleUrls: ['./sign-with-pin-code.component.scss']
})
export class SignWithPinCodeComponent implements OnInit {
    @ViewChild('form') form!: NgForm;

    @Input() isOpened = false;
    @Input() document!: CFDocumentToDisplay;
    @Output() public readonly isOpenedChange = new EventEmitter<boolean>();
    @Output() public readonly confirmAction = new EventEmitter<void>();
    @Output() public readonly onLoading = new EventEmitter<boolean>();

    public title!: string;
    public pinCode: string | undefined;

    constructor(
        public signatureService: CFSignatureService,
        private signatureStoreService: CFSignatureStoreService,
        private notificationService: CustomNotificationService,
        private msgService: CustomMessagesService
    ) {}

    ngOnInit(): void {
        this.title = this.msgService.translate('cf-signature.dialog.signWithPin.title');
    }

    public close(): void {
        this.isOpenedChange.emit(false);
    }

    public save(): void {
        if (!this.isOpened) {
            return;
        }
        this.form.control.markAllAsTouched();
        if (!this.form.valid) {
            return;
        }

        this.applyPinSignature();
    }

    public applyPinSignature(): void {
        this.onLoading.emit(true);
        const signatureForComplete = new CFSignatureForComplete(undefined, this.pinCode.toString());

        this.signatureService
            .completeSignature(this.document.cloudFlowId, this.signatureStoreService.signatureId, signatureForComplete)
            .pipe(untilDestroyed(this))
            .subscribe({
                next: () => {
                    this.notificationService.success(this.msgService.translate('cf-signature.notification.signatureComplete'));
                    this.onLoading.emit(false);
                    this.confirmAction.emit();
                },
                error: () => {
                    this.onLoading.emit(false);
                }
            });
    }
}
